module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-toolbar', {
    staticClass: "md-dense ql-cue-header",
    style: (_vm.style())
  }, [_c('layer-picker', {
    attrs: {
      "currentLayer": _vm.layer,
      "layers": _vm.layers,
      "editable": _vm.editable,
      "locked": _vm.locked
    },
    on: {
      "selectLayer": _vm.selectLayer
    }
  }), _vm._v(" "), (_vm.editable && !_vm.locked) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "md-body-1 cue-header-title",
    on: {
      "click": _vm.edit
    }
  }, [_vm._v(_vm._s(_vm.cue.title) + "\r\n        "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Click to edit")])], 1) : _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editing),
      expression: "!editing"
    }],
    staticClass: "md-body-1 cue-header-title"
  }, [_vm._v(_vm._s(_vm.cue.title))]), _vm._v(" "), (_vm.editing) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.submit($event)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.keyPress($event)
      }
    }
  }, [_c('md-input-container', [_c('md-input', {
    model: {
      value: (_vm.cue.title),
      callback: function($$v) {
        _vm.$set(_vm.cue, "title", $$v)
      },
      expression: "cue.title"
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Enter to save, Escape to cancel")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expanded),
      expression: "!expanded"
    }],
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggle
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_down")])], 1), _vm._v(" "), _c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expanded),
      expression: "expanded"
    }],
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggle
    }
  }, [_c('md-icon', [_vm._v("keyboard_arrow_up")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2dc3cfc0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/cues/cue-header.vue
// module id = 643
// module chunks = 2